import React, { useContext } from 'react';
import { APP_TYPE, REACT_APP_VERSION } from './config/Config';
import { AppDB } from './App';

export const AppFooter = ({ dataSource, environmentName }) => {
    var { lookUp } = useContext(AppDB);



    function getStatusColor(id) {
        switch (id) {
            case 4:
            case 3:
            case 6:
                return 'green'
            case 1:
            case 2:
                return 'red'
            case 7:
            case 1:
            case 5:
                return 'yellow'
            default:
                return 'gray'
        }
    }


    return (
        <>
            {APP_TYPE === "Central" && (<>
                <div className="layout-footer" style={{fontSize:10}}>
                    {/* <span className="font-medium ml-2 mr-2 " >Version - <b>{REACT_APP_VERSION}</b></span>  |  <span className="font-medium ml-2 mr-2" >Data Source -<b> {dataSource}</b></span>   |  <span className="font-medium ml-2 mr-2" >Environment - <b>{environmentName}</b></span> */}
                    <div className="grid-container card px-3">
                        <div className="grid">
                            <div className="col-12  md:col-4 my-0">
                                <span className="font-medium  mr-2 " >Version - <b>{REACT_APP_VERSION}</b></span>
                            </div>
                            <div className="col-12 md:col-4 my-0">
                                <span className="font-medium  mr-2" >Data Source -<b> {dataSource}</b></span>
                            </div>
                            <div className="col-12 md:col-4 my-0">
                                <span className="font-mediump-mr-2" >Environment - <b>{environmentName}</b></span>
                            </div>
                            {lookUp?.system_status?.map(e =>
                                <div className="col-12 md:col-4 my-0">
                                    <span>{e.name} - <b style={{ color: getStatusColor(e?.id) }}>
                                        {e.status}

                                    </b></span>
                                </div>
                            )}
                        </div>
                    </div>
                </div></>)}
        </>

    );
}